<template>
    <div class="tw-w-full tw-text-center tw-flex tw-justify-end tw-gap-2 tw-px-4">
        <!-- View Button -->
        <a-action-button 
            v-if="false"
            @click="$emit('view', props.item)" 
            icon="solar:eye-bold-duotone" 
            intent="info"
            :title="$t('buttons.view')"
        ></a-action-button>

        <!-- Edit Button -->
        <a-action-button 
            as="router-link"
            :to="{ name: 'pages.admin.companies.edit', params: { id: props.item.id } }"
            icon="solar:pen-bold-duotone" 
            intent="warning"
            :title="$t('buttons.edit')"
        ></a-action-button>

        <!-- Delete Button -->
        <a-action-button 
            @click="showDeleteModal = true" 
            icon="solar:trash-bin-2-bold-duotone" 
            intent="danger"
            :title="$t('buttons.delete')"
        ></a-action-button>

        <!-- Delete Confirmation Modal -->
        <DeleteModal 
            :visible="showDeleteModal" 
            :loading="loading.delete" 
            @confirm="onDeleteConfirmed" 
            @cancel="showDeleteModal = false" 
        />
    </div>
</template>

<script setup>
import { defineProps, ref, defineEmits } from 'vue';
import { useI18n } from 'vue-i18n';
import useAlert from '@/composables/useAlert';
import DeleteModal from '@/components/modals/DeleteModal.vue';
import companyApi from '@/api/companies';

const { t } = useI18n();

const props = defineProps({
    item: {
        type: Object,
        required: true
    }
});

const emit = defineEmits(['edit', 'delete', 'view']);

const showDeleteModal = ref(false);
const loading = ref({
    delete: false
});

const onDeleteConfirmed = async () => {
    loading.value.delete = true;
    
    try {
        await companyApi.admin.destroy(props.item.id);
        
        useAlert(t('messages.company-deleted', 'Company deleted successfully'), 'success');
        emit('delete', props.item);
        showDeleteModal.value = false;
    } catch (error) {
        console.error('Error deleting company:', error);
        useAlert(t('errors.something-went-wrong', 'Something went wrong'), 'danger');
    } finally {
        loading.value.delete = false;
    }
};
</script>

<style scoped>
/* Add any custom styles here */
</style> 